<template lang="html">
  <v-container
    class="text-center"
    fluid
    align-center
    justify-center
    v-if="loading"
    style="height: 7em;display: flex;"
  >
    <div>
      <v-progress-circular
        :size="30"
        color="primary"
        indeterminate
      />
    </div>
  </v-container>
  <div
    v-else
    style="height: 7em; width: 7em;"
    :style="wrapperStyles"
  >
    <chart
      :id="id"
      :options="options"
      ref="chart"
      style="height: 7em"
      @click="$emit('click')"
    ></chart>
  </div>
</template>

<script>
import Chart from '@/components/Chart'
import Highcharts from 'highcharts'
import getColor from './getColor'
import cloneDeep from 'lodash/cloneDeep'
import set from 'lodash/set'
import round from 'lodash/round'

const baseOptions = {
  chart: {
    type: 'solidgauge',
    backgroundColor: 'rgba(255, 255, 255, 0)'
  },
  title: {
    align: 'center',
    text: '',
    verticalAlign: 'middle',
    widthAdjust: -90,
    useHTML: true,
    y: -40,
    style: {
      fontSize: '30px'
    }
  },
  pane: {
    startAngle: 0,
    endAngle: 360,
    background: [{
      outerRadius: '112%',
      innerRadius: '88%',
      backgroundColor: Highcharts.Color(getColor())
        .setOpacity(0.1)
        .get(),
      borderWidth: 0
    }]
  },
  // the value axis
  yAxis: {
    min: 0,
    max: 100,
    lineWidth: 0,
    tickPositions: []
  },
  plotOptions: {
    solidgauge: {
      animation: false,
      dataLabels: {
        enabled: false
      },
      linecap: 'round',
      stickyTracking: false,
      rounded: false
    }
  },
  series: [{
    name: 'Percentage',
    data: [{
      color: getColor,
      radius: '112%',
      innerRadius: '88%',
      y: 0
    }]
  }],
  credits: {
    enabled: false
  }
}

export default {
  components: {
    Chart
  },
  props: {
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: 'Value'
    },
    value: {
      type: Number,
      default: 0
    },
    forceGray: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    wrapperStyles () {
      if (this.$route && this.$route.query && this.$route.query._screenshot) {
        return { backgroundColor: '#ffffff' }
      }
      return {}
    },
    options () {
      let options = cloneDeep(baseOptions)
      let value = round(this.value)
      let color = getColor(value, this.forceGray)
      options.pane.background[0].backgroundColor = Highcharts.Color(color).setOpacity(0.1).get()
      options.series[0].data[0].color = color
      options.title = {
        ...(options.title || {}),
        text: this.label.toUpperCase(),
        style: { fontSize: '20px' },
        y: -20
      }
      options.subtitle = {
        floating: true,
        text: `${value}%`,
        align: 'center',
        style: { fontSize: '30px', fontWeight: 'bold', color: '#000000' },
        y: 110
      }
      set(options, 'series.0.data.0.y', [value])
      return options
    }
  }
}
</script>
